<template>
  <v-container fluid class="ma-0 pt-0 mt-7 mt-md-0">
    <v-row v-show="current === 'login'">
      <v-col cols="12">
        <div
          class="text-center text-subtitle-1 text-sm-h5 text-md-h4 primary--text text-capitalize"
        >
          {{ $t('title_txt_welcome_1') }}
        </div>
        <div
          class="pt-md-4 text-center text-h6 text-sm-h4 text-md-h3 primary--text text-capitalize"
        >
          {{ $t('title_txt_welcome_2') }}
        </div>
      </v-col>
      <v-col cols="12">
        <v-row justify="center" no-gutters>
          <v-col v-if="$vuetify.breakpoint.mdAndUp" cols="12" md="4">
            <v-row justify="end" class="mt-md-2" no-gutters>
              <v-img
                class="mt-md-16 mr-md-1"
                max-height="350"
                max-width="300"
                src="page-decor/shopping-cart.svg"
              />
            </v-row>
          </v-col>
          <v-col cols="12" md="7">
            <v-row justify="center" justify-md="start">
              <v-col cols="12" md="6" sm="8">
                <v-row>
                  <v-col cols="12">
                    <v-form ref="loginRegisterForm" @submit.prevent>
                      <v-checkbox
                        required
                        :rules="[(v) => !!v || 'You must agree to continue']"
                        class="mt-n2"
                      >
                        <template v-slot:label>
                          <div
                            class="caption"
                            @click.stop
                            v-html="$t('cap_txt_policy')"
                          ></div>
                        </template>
                      </v-checkbox>
                      <v-text-field
                        v-model="phoneNumber"
                        :hint="$t('input_tip_phone')"
                        :placeholder="$t('input_txt_phone')"
                        persistent-hint
                        outlined
                        solo
                        single-line
                        append-icon="mdi-phone"
                        :rules="phoneNumberRule"
                        @keyup.enter="onLoginRegister"
                      ></v-text-field>
                      <span
                        v-if="error"
                        class="error--text caption d-flex justify-center"
                        >{{ $t('cap_msg_err_014') }}</span
                      >
                      <v-btn
                        id="login-register-in-button"
                        :loading="loading"
                        :disabled="loading"
                        outlined
                        class="primary--text"
                        large
                        block
                        @click="onLoginRegister"
                      >
                        {{ $t('btn_text_login_register') }}
                      </v-btn>
                    </v-form>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <v-img
                  class="mx-sm-auto mx-md-0 mt-md-3 mt-sm-0"
                  max-height="300"
                  :max-width="$vuetify.breakpoint.mdAndUp ? 700 : 600"
                  src="page-decor/businesses.svg"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-show="current === 'verify'">
      <v-row align="center" justify="center">
        <v-col cols="10" md="10">
          <v-row justify="center" align="center">
            <v-col cols="12">
              <v-row justify="center">
                <v-col v-show="$vuetify.breakpoint.mdAndUp" cols="12" md="5">
                  <v-row justify="end">
                    <v-img
                      class="mt-5 mt-sm-0"
                      max-height="350"
                      max-width="300"
                      src="page-decor/undraw_messages1_9ah2.svg"
                    />
                  </v-row>
                </v-col>
                <v-col cols="12" md="5">
                  <v-row justify="center" justify-md="start">
                    <v-col cols="12" md="10">
                      <div
                        class="text-left text-subtitle-1 text-sm-h5 text-md-h4 primary--text text-capitalize"
                      >
                        {{ $t('title_txt_verify_1') }}
                      </div>
                    </v-col>
                    <v-col cols="12" md="10">
                      <div
                        class="text-left caption"
                        v-html="
                          $t('cap_txt_instruction', { number: phoneNumber })
                        "
                      ></div>
                    </v-col>
                    <v-col cols="12" md="9">
                      <v-form ref="verifyCodeForm" @submit.prevent>
                        <v-text-field
                          v-model="verifyCode"
                          :hint="$t('cap_txt_see_label')"
                          placeholder="######"
                          persistent-hint
                          outlined
                          solo
                          single-line
                          append-icon="mdi-cellphone-message"
                          :rules="verifyCodeRule"
                          @keyup.enter="onVerifyCode"
                        ></v-text-field>
                        <span
                          v-if="error"
                          class="error--text caption d-flex justify-center"
                          >{{ $t('cap_msg_err_015') }}</span
                        >
                        <v-btn
                          outlined
                          class="primary--text"
                          large
                          block
                          :loading="loading"
                          :disabled="loading"
                          @click="onVerifyCode"
                        >
                          {{ $t('btn_text_verify') }}
                        </v-btn>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row align="center" justify="center">
            <v-col cols="12">
              <v-img
                class="mx-auto mt-5 mt-sm-0"
                max-height="300"
                :max-width="$vuetify.breakpoint.mdAndUp ? 600 : 500"
                src="page-decor/businesses.svg"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-row>
    <v-row v-show="current === 'wait'">
      <v-col cols="12">
        <div
          class="text-center text-subtitle-1 text-sm-h5 text-md-h4 primary--text text-capitalize"
        >
          {{ $t('title_txt_new_welcome') }}
        </div>
      </v-col>
      <v-col cols="12">
        <v-row justify="center" class="pt-0">
          <v-col cols="10" md="12">
            <v-row justify="center">
              <v-col cols="12">
                <v-row justify="center">
                  <v-col cols="12" md="5">
                    <v-row justify="center">
                      <v-col cols="12" md="5">
                        <v-img
                          class="mx-auto"
                          width="170"
                          max-height="270"
                          max-width="250"
                          src="page-decor/congrats.svg"
                        />
                      </v-col>
                      <v-col cols="12" md="7">
                        <div class="text-left text-subtitle-2 primary--text">
                          {{ $t('cap_txt_new_user') }}
                        </div>
                        <div class="mt-md-15 mt-2">
                          <v-icon color="primary">mdi-clock</v-icon>
                          <span> {{ $t('cap_msg_see_u') }}</span>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-col cols="12">
                <v-img
                  class="mx-auto mt-5 mt-sm-0"
                  max-height="300"
                  :max-width="$vuetify.breakpoint.mdAndUp ? 600 : 500"
                  src="page-decor/progress.svg"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
/* eslint-disable */
import PhoneNumber from 'awesome-phonenumber'

export default {
  created () {
    this.$firebase.auth.languageCode = this.$store.getters['account/lang']
  },
  mounted () {
    window.recaptchaVerifier = new this.$firebase.auth.RecaptchaVerifier('login-register-in-button', {
      'size': 'invisible',
      'callback': function (response) {
        // reCAPTCHA solved, allow signInWithPhoneNumber.
        console.warning('recaptcha solved')
      }
    })
  },
  data () {
    return {
      phoneNumber: '',
      verifyCode: '',
      loading: false,
      error: null
    }
  },
  methods: {
    onLoginRegister () {
      if (this.$refs.loginRegisterForm.validate()) {
        this.loading = true
        let pn
        this.phoneNumber = /\s/.test(this.phoneNumber)  ? this.phoneNumber.replace(/\s/g,'') : this.phoneNumber
        if (this.phoneNumber.startsWith('+') || !this.phoneNumber.startsWith('0')) {
          // this must be e164 format (i.e. prefixed with a +)
          this.phoneNumber = !this.phoneNumber.startsWith('+') ? `+${this.phoneNumber}` : this.phoneNumber
          pn = new PhoneNumber(this.phoneNumber)
        } else {
          // let use cambodia format here
          pn = new PhoneNumber(this.phoneNumber, 'KH')
        }
        this.phoneNumber = pn.getNumber('e164')
        this.$firebaseAuth.signInWithPhoneNumber(this.phoneNumber, window.recaptchaVerifier)
          .then(confirmResult => {
            console.warn('success', confirmResult)
            window.confirmationResult = confirmResult
            this.error = null
            this.nextStep()
          }).catch(error => {
            console.error('failed', error)
            this.error = error
            this.$refs.loginRegisterForm.reset()
            window.recaptchaVerifier.render().then(function(widgetId) {
              grecaptcha.reset(widgetId)
            })
          }).finally(() => {
            this.loading = false
        })
      }
    },
    onVerifyCode () {
      if (this.$refs.verifyCodeForm.validate()) {
        this.loading = true
        window.confirmationResult.confirm(this.verifyCode).then((result) => {
          // User signed in successfully.
          const user = result.user
          console.info('user has been logged in', user)
          this.error = null
          this.nextStep()
        }).catch((error) => {
          console.error('failed', error)
          this.error = error
        }).finally(() => {
          this.loading = false
        })
      }
    },
    nextStep () {
      this.$store.commit('account/nextStep')
    }
  },
  computed: {
    current () {
      return this.$store.state.account.current
    },
    phoneNumberRule () {
      return [
        v => !!v || this.$t('cap_msg_err_001'),
        v => {
          // 039 is special case of phone number from (star Digital/Kingtel Network)
          v = /\s/.test(v) ? v.replace(/\s/g,'') : v
          if(!v.startsWith('039') && !v.startsWith('+85539')) {
            let pn
            if (v.startsWith('+') || !v.startsWith('0')) {
              // this must be e164 format (i.e. prefixed with a +)
              v = !v.startsWith('+') ? `+${v}` : v
              pn = new PhoneNumber(v)
            } else {
              // let use cambodia format here
              pn = new PhoneNumber(v, 'KH')
            }
            return pn.isValid() || this.$t('cap_msg_err_001')
          } else {
            let format = /^[0-9]{9,10}$/
            if (v.startsWith('+85539')) {
              format = /^['+']{1}[0-9]{11,12}$/
            }
            return format.test(v) || this.$t('cap_msg_err_001')
          }
          return true
        },
        v => {
          v = /\s/.test(v) ? v.replace(/\s/g,'') : v
          const format = /^['+']{0,1}[0-9]*$/
          return format.test(v) || this.$t('cap_msg_err_001')
        }
      ]
    },
    verifyCodeRule () {
      return [
        v => !!v || this.$t('cap_msg_err_003'),
        v => (v && v.length === 6) || this.$t('cap_msg_err_003')
      ]
    }
  }
}
</script>
